import PropTypes from 'prop-types';
/**
 * A wrapper component for detaching the children components from their original parent to a given DOM node
 * Useful for dynamically rendering a given component out of the component parent tree. For example: Modal
 *
 * Example:
 * <DetachableElement
 *   isEnabled={this.props.isDetached}
 *   targetSelector={document.getElementById('xyzzy')}>
 *   <div>This div will appear elsewhere in the DOM</div>
 * </DetachableElement>
 *
 * Caveats:
 * `detachTarget` must be a node outside of component tree
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { mapValues } from 'lodash';
import { unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer } from 'react-dom';

export default class DetachableElement extends React.Component {
    componentDidMount() {
        this.update();
    }

    componentDidUpdate() {
        this.update();
    }

    componentWillUnmount() {
        var currentNode = this.currentDetachedTargetNode;

        if (currentNode) {
            ReactDOM.unmountComponentAtNode(currentNode);
        }
    }

    getNode() {
        if (!this.node) {
            this.node = document.createElement('div');
            document.body.appendChild(this.node);
        }

        return this.node;
    }

    getTargetNodeToDetach() {
        if (this.props.targetSelector) {
            return document.querySelector(this.props.targetSelector);
        }

        return this.getNode();
    }

    setCurrentDetachedTargetNode(node) {
        var currentNode = this.currentDetachedTargetNode;

        if (currentNode && currentNode !== node) {
            ReactDOM.unmountComponentAtNode(currentNode);
        }

        this.currentDetachedTargetNode = node;
    }

    update() {
        var targetNode = null;

        if (this.props.isEnabled) {
            targetNode = this.getTargetNodeToDetach();
            renderSubtreeIntoContainer(this, this.props.children, targetNode);
        }

        this.setCurrentDetachedTargetNode(targetNode);
    }

    render() {
        if (this.props.isEnabled) {
            return null;
        } else {
            return this.props.children;
        }
    }
}

DetachableElement.propTypes = {
    isEnabled: PropTypes.bool.isRequired,
    targetSelector: PropTypes.string,
};

DetachableElement.defaultProps = {
    isEnabled: true,
    targetSelector: null
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/DetachableElement.jsx